import { useState, useEffect, createContext, useContext } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // 'light', 'dark', o 'system'
  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem('themeMode') || 'system';
  });

  // El tema efectivo (light o dark) basado en themeMode
  const [effectiveTheme, setEffectiveTheme] = useState('light');

  // Calcular tema efectivo
  useEffect(() => {
    const getEffectiveTheme = () => {
      if (themeMode === 'system') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      }
      return themeMode;
    };

    const updateTheme = () => {
      const theme = getEffectiveTheme();
      setEffectiveTheme(theme);
      
      const root = window.document.documentElement;
      if (theme === 'dark') {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
    };

    updateTheme();
    localStorage.setItem('themeMode', themeMode);

    // Escuchar cambios en preferencias del sistema
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (themeMode === 'system') {
        updateTheme();
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [themeMode]);

  // Ciclar entre: light -> dark -> system -> light
  const cycleTheme = () => {
    setThemeMode(prev => {
      if (prev === 'light') return 'dark';
      if (prev === 'dark') return 'system';
      return 'light';
    });
  };

  // Mantener toggleTheme para compatibilidad (ahora cicla)
  const toggleTheme = cycleTheme;

  // Setear modo específico
  const setTheme = (mode) => {
    if (['light', 'dark', 'system'].includes(mode)) {
      setThemeMode(mode);
    }
  };

  return (
    <ThemeContext.Provider value={{ 
      theme: effectiveTheme,  // 'light' o 'dark' efectivo
      themeMode,              // 'light', 'dark', o 'system'
      toggleTheme,            // cicla entre los 3
      cycleTheme,             // alias
      setTheme                // setear modo específico
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
